import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RouterModule } from '@angular/router';
import { GoFrequencyTypeRendererParams } from './models/go-frequency-type-renderer-params';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-go-frequency-type-cell-renderer',
    imports: [RouterModule, CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-frequency-type-cell-renderer.component.html',
})
export class GoFrequencyTypeCellRendererComponent
    implements ICellRendererAngularComp
{
    params: GoFrequencyTypeRendererParams = {} as GoFrequencyTypeRendererParams;

    agInit(params: ICellRendererParams & GoFrequencyTypeRendererParams): void {
        this.params = params as GoFrequencyTypeRendererParams;
    }

    refresh(): boolean {
        return false;
    }

    isResultAsRequested(): boolean {
        return this.params.value === this.params.stationClassType;
    }
}
